<template>
  <div v-if="showModal" class="modal false z-50 fixed w-full h-full top-0 left-0 flex items-center justify-center">
    <div class="absolute w-full h-full bg-gray-900 opacity-50 modal-overlay"></div>
    <div class="z-50 rounded-lg p-5 bg-white"><Loader/></div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      showModal: false,
    }
  },
  beforeMount() {
    this.$emitter.on('open-loader-modal', () => {
      this.showModal = true
    })
    this.$emitter.on('close-loader-modal', () => {
      this.showModal = false
    })
  },
  beforeUnmount() {
    this.$emitter.off('open-loader-modal')
    this.$emitter.off('close-loader-modal')
  }
}
</script>